import { useMutation } from '@apollo/client/react';
import { UPDATE_ESNI_RULE } from '@optools/services/operator-gateway/esni/mutations';
import { ESNI_RULES } from '@optools/services/operator-gateway/esni/queries';
import { EsniRule } from '@optools/services/operator-gateway/types/generated/graphql';
import { toast } from 'sonner';

import { RuleForm, RuleFormType } from './rule-form';

export interface UpdateEsniRuleProps {
  onReset: () => void;
  rule: EsniRule;
}

export function UpdateEsniRule({ onReset, rule }: UpdateEsniRuleProps) {
  const [updateEsniRule, { loading }] = useMutation(UPDATE_ESNI_RULE, {
    awaitRefetchQueries: true,
    onCompleted: () => {
      toast.success('Updated Esni rule');
      onReset();
    },
    refetchQueries: [{ query: ESNI_RULES }],
  });

  const { id } = rule;

  const handleSubmit = (input: RuleFormType) => {
    updateEsniRule({
      variables: {
        input,
        ruleId: id,
      },
    });
  };

  const handleReset = () => {
    onReset();
  };

  return (
    <RuleForm
      defaultFormValues={rule}
      loading={loading}
      onReset={handleReset}
      onSubmit={handleSubmit}
    />
  );
}
